import { getsafe } from '@/libs/util.js'
import {postUploadDataApi} from '@/views/fin/account_management/services.js'
export default {
    data() {
        return {
            uploading:false,
        }
    },
    methods: {
        upload(data) {
        
         
            this.el = document.createElement('input')
            this.el.setAttribute('type', 'file')
         
            if (this.need_upload_id) {
                this.el.source_data = data
            }
            this.$refs.contain.appendChild(this.el)
            this.el.click()
            this.el.addEventListener('change', this.uploadFile)
        },
          uploadFile() {
            const record_id = this.need_upload_id ? getsafe(this.el, 'source_data.id') : null
            const account_id = this.need_upload_id ? getsafe(this.item, 'id') : null
            const file = this.el.files[0]
          
            const format = ['xlsx', 'csv']
            const arr = (format || []).map(item => new RegExp(item + '$'))
            if (arr.some(item => (item.test(file.type) || item.test(file.name)))) {
              if (file.name.indexOf('%') > -1) {
                this.$Modal.error({
                  title: '提示',
                  content: '文件名不能包含百分号%'
                });
                return
              }
        
              const formData = new FormData();
              formData.append('file', file)
              if (this.need_upload_id) {
                formData.append('record_id', record_id)
                formData.append('account_id', account_id)
              }

              this.uploading = true
              postUploadDataApi({formData}).then(() => {
                if (this.proxyGetData) {
                    this.$nextTick(this.proxyGetData)
                }
                if (!this.proxyGetData && this.getData) {
                    this.$nextTick(this.getData) 
                }
               
              }).finally(() => {
                this.uploading = false
              })
            } else {
              this.$Modal.error({
                title: '提示',
                content: `请上传${format.join('、')}格式文件`
              })
            }
            this.el.removeEventListener('change', this.uploadFile)
            const childrenInputs = this.$refs.contain.childNodes
            for (let i = 0, len = childrenInputs.length; i < len; i++) {
              this.$refs.contain.removeChild(childrenInputs[i])
            }
            this.el = null
          },
    }
}